import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';

import { ConciliacaoService } from '../services/conciliacao.service';
import { DadosConciliacao } from '../models/dados-conciliacao';
import { ConciliacaoApiService } from '../services/conciliacao-api.service';
import { MessageService } from '@services/message.service';
import { ModoPaginaEnum } from '../../../../models/enum/modo-pagina-enum';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';
import { MatDialog } from '@angular/material/dialog';
import { Permissao } from '@models/enums/permissao';

@Component({
  selector: 'app-conciliacao',
  templateUrl: './conciliacao.component.html',
  styleUrl: './conciliacao.component.scss',
  standalone: false,
})
export class ConciliacaoComponent implements OnInit {

  get dadosConciliacao(): DadosConciliacao { return this.conciliacaoService.dadosConciliacao; }
  excelFileType: string = ".xlsx";
  title: string = '';
  voltarLink: string = '';

  get isHistorico(): boolean {
    return this.dadosConciliacao.conciliacaoId !== 0 && this.dadosConciliacao.modoPagina !== ModoPaginaEnum.Edicao;
  }

  protected get permissaoExportarConciliacao() { return Permissao.EXPORTAR_CONCILIACAO; }
  protected get permissaoEditarConciliacao() { return Permissao.EDITAR_CONCILIACAO; }

  constructor(
    private route: ActivatedRoute,
    private conciliacaoService: ConciliacaoService,
    private conciliacaoApiService: ConciliacaoApiService,
    private messageService: MessageService,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      this.conciliacaoService.setDadosConciliacao(data['dadosConciliacao']);
      this.title = this.getTabTitle();
      this.voltarLink = `/historico-conciliacao/${this.dadosConciliacao.contaId}`
    });
  }

  private getTabTitle(): string {
    if (this.dadosConciliacao.conciliacaoId === 0) return `Nova conciliação de ${this.dadosConciliacao.nomeBanco}`;
    else if (!this.isHistorico) return `Editando ultima conciliação de ${this.dadosConciliacao.nomeBanco}`;
    else return `Visualizando conciliação do histórico de ${this.dadosConciliacao.nomeBanco}`;
  }

  private exportarConciliacao(): void {
    const info = this.conciliacaoService.getInformacoesSalvarConciliacao();

    this.conciliacaoApiService.salvarConciliacao(info).subscribe((dados) => {
      this.messageService.showToastSuccess("Salvo com sucesso.");
      this.conciliacaoService.setDadosConciliacao(dados);
      this.conciliacaoApiService.exportarConciliacao(this.dadosConciliacao);
    });
  }

  public salvar(): void {
    const info = this.conciliacaoService.getInformacoesSalvarConciliacao();

    this.conciliacaoApiService.salvarConciliacao(info).subscribe((dados) => {
      this.messageService.showToastSuccess("Salvo com sucesso.");
      this.conciliacaoService.setDadosConciliacao(dados);
      const httpUrl = `/historico-conciliacao/${info.contaId}`;
      this.router.navigateByUrl(httpUrl);
    });
  }

  public exportarConciliacaoClick(): void {
    if (this.conciliacaoService.modoPagina === ModoPaginaEnum.Edicao) {
      const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
        width: '467px',
        panelClass: 'no-padding-dialog',
        autoFocus: false
      });
      dialogRef.componentInstance.titulo = "Exportar conciliação";
      dialogRef.componentInstance.mensagem = `Para exportar a conciliação é necessário salvar o estado atual.`;
      dialogRef.componentInstance.mensagemBold = 'Deseja prosseguir?';
      dialogRef.componentInstance.acaoConfirmacao = this.exportarConciliacao.bind(this);
    }
    else {
      this.exportarConciliacao();
    }
  }
}
